import { useLocalZonePreference } from '@/hooks/useLocalZonePreference';
import { Source } from '@/types/evals';
import { formatTimestamp } from '@/utils/timeFormatter';

import { InfoCard } from '../../_components/InfoCard';
import styles from './FooterRow.module.scss';

type Props = {
  source: Source;
};

export function FooterRow( { source }: Props ) {
  const [ useLocalZone ] = useLocalZonePreference();

  return (
    <div className={ styles.row } data-testid="version-footer-row">
      <InfoCard label="Version Created" value={ formatTimestamp( source.version_created_at, useLocalZone ) } />
      <InfoCard label="Version Updated" value={ formatTimestamp( source.version_updated_at ?? undefined, useLocalZone ) } />
      <InfoCard label="Version Created By" value={ source.version_created_by ?? '—' } />
      <InfoCard label="Deprecated" value={ source.is_deprecated ? 'true' : 'false' } />
      <InfoCard label="Status" value={ source.status } />
    </div>
  );
}
